import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { useParams, Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import TabMenu from "./TabMenu";
import PropertyListComponent from "../propertyNew/PropertyListComponent";
import "./Myspace.css";

const SELECT_OPTIONS = [
  { label: "Shared", value: "Shared" },
  { label: "Posts", value: "post" },
  { label: "Properties", value: "property" },
  { label: "Follow", value: "follow" },
];

const Myspace = () => {
  const { Id } = useParams();
  const loggedInUser = useSelector((state) => state.auth.user);

  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [data, setData] = useState([]);
  const [selectedValue, setSelectedValue] = useState("property");
  const [assetUrl, setAssetUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const capitalizeFirstLetter = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1);

  const normalizeLeads = (leads) =>
    leads.map((lead) => ({
      is_published: lead?.published ?? false,
      active: lead.active,
      deleted: lead.deleted,
      id: lead.id,
      title: lead.title ?? null,
      description: lead.description,
      budget: lead.budget ?? null,
      created_on: lead.created_on,
      customer_id: lead.customer_id,
      customer_name: lead.customer_name,
      partner_id: lead.partner_id,
      partner_name: lead.partner_name,
      comment_count: lead.comment_count,
      area_name: lead.area_name,
      city_name: lead.city_name,
      state_name: lead.state_name,
      country_name: lead.country_name,
      images: lead?.images ?? [],
    }));

  // ── Data Fetching ─────────────────────────────────────────────────────────

  const fetchData = async (pageNumber, pageSize = 10) => {
    setIsLoading(true);

    const postData = {
      search_type: capitalizeFirstLetter(selectedValue),
      page_number: pageNumber,
      page_size: pageSize,
      order_by: "DSC",
    };

    try {
      const response = await axios.post(
        `${baseUrl}/property/list/my/space`,
        postData,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      const resData = response.data;

      if (selectedValue === "post" && resData.leads) {
        resData.leads = normalizeLeads(resData.leads);
      }

      if (
        (selectedValue === "property" || selectedValue === "follow") &&
        resData.properties
      ) {
        setData(resData.properties);
        setAssetUrl(resData.assetUrl ?? "");
      } else if (selectedValue === "post" && resData.leads) {
        setData(resData.leads);
        setAssetUrl(resData.assetUrl ?? "");
      } else {
        setData([]);
      }

      setTotalPages(
        resData.totalPage && resData.totalPage > 0 ? resData.totalPage : 1,
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [selectedValue, currentPage]);

  const handleFilterChange = (option) => {
    setSelectedValue(option.value);
    setCurrentPage(1);
  };

  return (
    <div className="myspace">
      <div className="myspace__inner">
        <aside className="myspace__sidebar">
          <TabMenu />
        </aside>

        <main className="myspace__content">
          <div className="myspace__filter-bar">
            <span className="myspace__filter-label">Filter by</span>
            <div className="myspace__filter-pills">
              {SELECT_OPTIONS.map((opt) => (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => handleFilterChange(opt)}
                  className={`myspace__pill${
                    selectedValue === opt.value ? " myspace__pill--active" : ""
                  }`}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>

          <div className="myspace__body">
            {isLoading ? (
              <div className="myspace__loader">
                <Loader2 className="myspace__loader-icon" size={32} />
                <span className="myspace__loader-text">Loading listings…</span>
              </div>
            ) : Id ? (
              <Outlet />
            ) : (
              <PropertyListComponent
                route="/dashboard/myspace"
                apiPath="/property/list/my/space"
                method="POST"
                requiresAuth={true}
                mySpace={true}
                selectedValue={selectedValue}
              />
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Myspace;
